import React from "react";

/**
 * 24-spoke Ashoka Chakra rendered as inline SVG.
 * Color is controlled via `currentColor`.
 */
export default function AshokaChakra({ size = 24, className = "" }) {
    const spokes = Array.from({ length: 24 }, (_, i) => i * 15);
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 100 100"
            className={className}
            aria-hidden="true"
        >
            <circle
                cx="50"
                cy="50"
                r="46"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
            />
            <circle cx="50" cy="50" r="6" fill="currentColor" />
            <g
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                fill="none"
            >
                {spokes.map((deg) => (
                    <line
                        key={deg}
                        x1="50"
                        y1="50"
                        x2="50"
                        y2="6"
                        transform={`rotate(${deg} 50 50)`}
                    />
                ))}
            </g>
        </svg>
    );
}
